import { GeometryUtil } from 'leaflet';
import React, { Component } from 'react';
import { Rect, Group } from 'react-konva';

export class VerticalTabularDayTimesheetComponentCanvas extends Component {
    render() {
        const { geometry, component, isSelected, dimentionsRatio, draggable, geometryIndex, selectedGeometryIndex } = this.props;

        const geometryWidthRatio = geometry.width / 1100.0;
        const geometryHeightRatio = geometry.height / 650.0;

        const smallHeight = 50 * geometryHeightRatio * dimentionsRatio;
        const bigHeight = 550 * geometryHeightRatio * dimentionsRatio;
        const smallWidth = 100 * geometryWidthRatio * dimentionsRatio;
        const bigWidth = 250 * geometryWidthRatio * dimentionsRatio;

        const elementsMarginPosX = 50 * geometryWidthRatio * dimentionsRatio;
        const elementsPosX = geometry.drawPositionX + elementsMarginPosX;
        const tableElementsPositionX = elementsPosX + bigWidth + elementsMarginPosX;
        
        const elementsMarginPosY = 50 * geometryHeightRatio * dimentionsRatio;
        const descriptionPosY = geometry.drawPositionY + elementsMarginPosY;
        let tableElementPosY = geometry.drawPositionY + 50 * geometryHeightRatio * dimentionsRatio;

        const isAdditionalGeometry = geometryIndex > 0;
        const componentSecundaryColor = isAdditionalGeometry ? "#ddddddff" : "#EBF5FA";
        const mainFillColor = isAdditionalGeometry ? "#b6b4b4ff" : component.color;

        const geometryWidth = geometry.width * dimentionsRatio;
        const geometryHeight = geometry.height * dimentionsRatio;
        
        const colElements = [];
        let i;
        for (i = 0; i < 6; i++) {
            let j;
            for (j = 0; j < 5; j++) {
                colElements.push(
                    <Rect key={`${i}-${j}`}
                        x={tableElementsPositionX + smallWidth * j + elementsMarginPosX * j}
                        y={tableElementPosY}
                        width={smallWidth}
                        height={smallHeight}
                        strokeWidth={1}
                        stroke={isAdditionalGeometry ? "#808080" : "black"}
                        fill={componentSecundaryColor} />
                );

            }

            tableElementPosY += smallHeight + elementsMarginPosY;
        }

        return (
            <Group
                offsetX={geometry.offsetX}
                offsetY={geometry.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId, geometryIndex) : null} >
                <Rect x={geometry.drawPositionX}
                    y={geometry.drawPositionY}
                    width={geometryWidth}
                    height={geometryHeight}
                    strokeWidth={isSelected && Number(geometryIndex) === Number(selectedGeometryIndex) ? 4 : isSelected ? 2 : 1}
                    stroke={isSelected && Number(geometryIndex) === Number(selectedGeometryIndex) ? "#6699ff" : isSelected ? "#6699ff" : "#000000ff"}
                    fill={mainFillColor} />

                <Group>
                    <Rect x={elementsPosX}
                        y={descriptionPosY}
                        width={bigWidth}
                        height={bigHeight}
                        strokeWidth={1}
                        stroke={isAdditionalGeometry ? "#808080" : "black"}
                        fill={componentSecundaryColor}/>
                </Group>

                <Group>
                    {colElements}
                </Group>
            </Group>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/componentCanvas/VerticalTabularDayTimesheetComponentCanvas.js